.chart {
  position: relative;
  width: 100%;
}

.chart svg {
  display: block;
  overflow: visible;
}

.grid {
  stroke: var(--line);
  stroke-width: 1;
}

.axis {
  fill: var(--muted);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
}

.crosshair {
  stroke: var(--muted-dim);
  stroke-width: 1;
  stroke-dasharray: 3 3;
}

.dot {
  stroke: var(--surface);
  stroke-width: 2;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0 0 8px;
  padding: 0;
  list-style: none;
  font-size: 13px;
  color: var(--muted);
}

.legend li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.swatch {
  display: inline-block;
  flex: 0 0 10px;
  width: 10px;
  height: 10px;
  border-radius: 3px;
}

.tooltip {
  position: absolute;
  top: 28px;
  z-index: 2;
  min-width: 160px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--bg-raised);
  box-shadow: 0 12px 32px rgb(0 0 0 / 25%);
  font-size: 13px;
  pointer-events: none;
}

.tooltipTitle {
  margin-bottom: 6px;
  color: var(--text);
  font-weight: 500;
}

.tooltipRow {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--muted);
}

.tooltipValue {
  margin-left: auto;
  padding-left: 12px;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.hbars {
  display: grid;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.hbarHead {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
  font-size: 14px;
}

.hbarValue {
  font-variant-numeric: tabular-nums;
}

.hbarTrack {
  height: 8px;
  border-radius: 4px;
  background: var(--pill-bg);
  overflow: hidden;
}

.hbarFill {
  height: 100%;
  border-radius: 4px;
}

.kpi {
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-panel);
  background: var(--surface);
}

.kpiLabel {
  color: var(--muted);
  font-size: 13px;
}

.kpiValue {
  margin-top: 4px;
  font-family: var(--font-display);
  font-size: 30px;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.kpiHint {
  margin-top: 4px;
  color: var(--muted);
  font-size: 12px;
}
